import { Pipe, PipeTransform } from '@angular/core';

import { Config } from '../config';

import * as moment from 'moment';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'momentDate',
})
export class MomentDatePipe implements PipeTransform {
  public constructor(private cService: CommonService) {}

  transform(value: Date | number | string, momentFormat?: string) {
    const dateFormat: string = momentFormat ? momentFormat : Config.momentDateFormatUs;
    return moment(value).locale(this.cService.matLangCode).format(dateFormat);
  }
}
